import { prefixerRDEP, prefixerT } from '.'

export const ROUTE_MIGRAR_EXCEL_RDEP = prefixerRDEP('migrar-excel')
export const ROUTE_GENERAR_XML_ATS = prefixerT('generar-xml-ats')
export const ROUTE_GENERAR_XML_RDEP = prefixerRDEP('generar-xml')
export const ROUTE_ANULACION_DOCUMENTOS_ELECTRONICOS = prefixerT('anulacion-documentos-electronicos')
export const ROUTE_SOLICITUD_ANULACION_DOCUMENTOS_ELECTRONICOS = prefixerT(
    'solicitud-anulacion-documentos-electronicos'
)
export const ROUTE_DOCUMENTO_RETENCION = prefixerT('documento-retencion')
export const ROUTE_BANDEJA_DOCUMENTOS_RETENCION = 'tributacion-pg:transacciones:bandeja-documento-retencion'
